'use client';
import { useRef, useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { jsx } from '@emotion/react/jsx-runtime';
import _styled from '@emotion/styled/base';
import { MEDIA_QUERY } from '@bucketplace/design-system';
import { Modal } from '@bucketplace/design-system/bds';
import { useTheme } from '@emotion/react';

class ScriptLoader {
  constructor() {
    this.cachedPromise = null;
  }
  load(scriptSrc, getScript, setupScript, async) {
    const selectedScript = document.querySelector(`script[src="${scriptSrc}"]`);
    if (selectedScript != null && this.cachedPromise != null) {
      return this.cachedPromise;
    }
    if (selectedScript != null && getScript() != null) {
      setupScript?.();
      return Promise.resolve(getScript());
    }
    const script = document.createElement('script');
    script.src = scriptSrc;
    if (async) {
      script.async = async;
    }
    this.cachedPromise = new Promise(resolve => {
      document.head.appendChild(script);
      script.addEventListener('load', () => {
        setupScript?.();
        resolve(getScript());
      });
    });
    return this.cachedPromise;
  }
}

const SCRIPT_SRC = 'https://assets.ohou.se/address/index.js';
const loadAddressScript = async () => {
  const addressScript = new ScriptLoader();
  const renderAddressSearch = await addressScript.load(SCRIPT_SRC, () => window.renderAddressSearch);
  return renderAddressSearch;
};

const useAddressSearch = () => {
  const addressSearchRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    (async () => {
      const renderAddressSearch = await loadAddressScript();
      addressSearchRef.current = renderAddressSearch;
      setLoaded(true);
    })();
  }, []);
  if (!loaded) {
    return null;
  }
  return addressSearchRef.current;
};

const AddressSearchContent = ({
  addressOptions,
  ...props
}) => {
  const renderAddressSearch = useAddressSearch();
  const divRef = useRef(null);
  useEffect(() => {
    if (renderAddressSearch != null && divRef.current != null) {
      renderAddressSearch(divRef.current, addressOptions);
    }
  }, [renderAddressSearch, divRef, addressOptions]);
  useEffect(() => {
    return () => {
      if (divRef.current != null) {
        ReactDOM.unmountComponentAtNode(divRef.current);
      }
    };
  }, [divRef]);
  return jsx("div", {
    ...props,
    ref: divRef
  });
};

const AddressSearchModal = ({
  addressOptions,
  width = 400,
  ...props
}) => {
  const theme = useTheme();
  const themeMode = useMemo(() => {
    if (theme.background.base === '#17181A') {
      return 'dark';
    }
    return addressOptions?.themeMode || 'light';
  }, [theme, addressOptions]);
  return (
    // @ts-ignore
    jsx(SearchModal, {
      width: width,
      header: props.header || {
        title: '주소 검색'
      },
      ...props,
      children: jsx(Content, {
        addressOptions: {
          ...addressOptions,
          themeMode
        }
      })
    })
  );
};
const SearchModal = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  target: "ebh0t0b1"
} : {
  target: "ebh0t0b1",
  label: "SearchModal"
})("&>div{height:100%;max-height:645px;", MEDIA_QUERY.max('tablet', `
      max-height: 90%;
    `), " ", MEDIA_QUERY.min('tablet', `
      overflow: hidden;
    `), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Content = /*#__PURE__*/_styled(AddressSearchContent, process.env.NODE_ENV === "production" ? {
  target: "ebh0t0b0"
} : {
  target: "ebh0t0b0",
  label: "Content"
})("max-height:645px;height:100%;", MEDIA_QUERY.max('tablet', `
    max-height: none;
  `), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export { AddressSearchContent, AddressSearchModal, loadAddressScript, useAddressSearch };
//# sourceMappingURL=index.esm.js.map
